export default function setSearchDateToAction(searchDateTo) {
    return {
        type: 'SET_SEARCH_DATE_TO',
        payload: searchDateTo
    }
}